import filter from "lodash/filter"

export const mapTypesEnum = {
  MAP_WITH_CARD_LIST_DESKTOP: "map_with_card_list_desktop",
  MAP_WITH_CARD_LIST_MOBILE: "map_with_card_list_mobile",
  MAP_WITHOUT_CARD_LIST: "map_without_card_list"
}

export const getMapOptions = type => {
  switch (type) {
    case mapTypesEnum.MAP_WITH_CARD_LIST_DESKTOP:
      return {
        scaleControl: true,
        fullscreenControl: false,
        mapTypeControlOptions: {
          mapTypeIds: ["roadmap", "satellite"]
        },
        styles: [
          {
            featureType: "poi.business",
            stylers: [{ visibility: "off" }]
          },
          {
            featureType: "transit",
            elementType: "labels.icon",
            stylers: [{ visibility: "off" }]
          }
        ]
      }
    case mapTypesEnum.MAP_WITH_CARD_LIST_MOBILE:
      return {
        scaleControl: true,
        fullscreenControl: false,
        mapTypeControlOptions: {
          mapTypeIds: ["roadmap", "satellite"]
        },
        styles: [
          {
            featureType: "poi.business",
            stylers: [{ visibility: "off" }]
          },
          {
            featureType: "transit",
            elementType: "labels.icon",
            stylers: [{ visibility: "off" }]
          }
        ]
      }
    default:
      return {
        scaleControl: true,
        fullscreenControl: false,
        mapTypeControlOptions: {
          mapTypeIds: ["roadmap", "satellite"]
        },
        styles: [
          {
            featureType: "poi.business",
            stylers: [{ visibility: "off" }]
          },
          {
            featureType: "transit",
            elementType: "labels.icon",
            stylers: [{ visibility: "off" }]
          }
        ]
      }
  }
}

export const getValidMarkers = markers => {
  return filter(
    markers,
    m =>
      m.coordinates.latitude >= -90 &&
      m.coordinates.latitude <= 90 &&
      m.coordinates.longitude >= -180 &&
      m.coordinates.longitude <= 180
  )
}
